var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MyCustomComp',{attrs:{"myData":_vm.array},on:{"valueChanged":(e) => { _vm.array = e }}}),_vm._l((_vm.array),function(option,i){return _c('p',{key:option.value + '' + i},[_vm._v(_vm._s(option.value))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }